import { css } from 'styled-components';

import { getMediaQuery } from '~/utils/responsive/media';

export const tabletAndMobileOnlyMixin = css`
  ${getMediaQuery('laptop', 'desktop')} {
    display: none;
  }
`;
